<template>
	<form v-if='selected_act' class='form' @submit.stop.prevent="submit">
		<h4>Заключение на группу актов ЛПО</h4>
		<div class="row">
			<div class="col-md-1 col">№ акта ЛПО</div>
			<div class="col-md-2 col">Организация</div>
			<div class="col-md-6 col">Ссылка на акт</div>
		</div>
		<div class="row">
			<div class="col-md-1 col">
				<select class='form-control form-control my-control' v-model='selected_act'>
					<option v-for='act in group_acts' :value='act.act_id'>
						{{ act.act_num }}
					</option>
				</select>
			</div>
			<div class="col-md-2 col"><organization :id='selected_act' :org_id='f_11' disabled></organization></div>
			<div class="col-md-6 col"><input type="text" class='form-control my-control' :value='f_4' disabled></input></div>
		</div>
		<div class="row">
			<div class="col-md-3 col">Федеральный округ</div>
			<div class="col-md-3 col">Субъект РФ</div>
			<div class="col-md-3 col">Лесничество</div>
		</div>
		<div class="row">
			<div class="col-md-3 col"><fo :reg_id='f_12' disabled></fo></div>
			<div class="col-md-3 col">
				<region type='conclusion' :reg_id='f_12' disabled></region>
			</div>
			<div class="col-md-3 col">
				<forestry type='conclusion' :reg_id='f_12' :f_id='f_9' disabled></forestry>
			</div>
		</div>
		<hr>

		<div class="row">
			<div class="col-md-9">
				<table class='documentsTable'>
					<thead>
						<tr>
							<th>Официальные документы</th>
							<th>Дата *</th>
							<th>Номер *</th>
							<th>Комментарий к документу</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td style='border-right: none'>Реквизиты исходящего из ДЛХ</td>
							<td :class='fields_correct.f_35'><datepicker
									v-model='f_35'
									format='dd.MM.yyyy'
									:disabled='readonly'
									class='table-control'
								></datepicker></td>
							<td :class='fields_correct.f_36'><input class="table-control form-control my-control" v-model='f_36' :disabled='readonly'></input></td>
							<td><input class="table-control form-control my-control" v-model='f_37' :disabled='readonly'></input></td>
						</tr>
						<tr>
							<td style='border-right: none'>Реквизиты входящего в Рослесозащиту</td>
							<td><datepicker
									v-model='f_38'
									format='dd.MM.yyyy'
									:disabled='readonly'
									class='table-control'
								></datepicker></td>
							<td><input class="table-control form-control my-control" v-model='f_39' :disabled='readonly'></input></td>
							<td><input class="table-control form-control my-control" v-model='f_40' :disabled='readonly'></input></td>
						</tr>
					</tbody>
				</table>
			</div>
			<!--
				<div class='col-md-1 text-right' style='line-height: 24px; font-size: 13px; font-weight: bold;'>
					№ акта ЛПО
				</div>

				<div class='col-md-2'>
					<select class='form-control form-control my-control' v-model='selected_act'>
						<option v-for='act in $parent.group_acts' :value='act.act_id'>
							{{ act.act_num }}
						</option>
					</select>
				</div>
			-->
		</div>
		<div class="row">
			<div class="col-md-9">
				<table class='documentsTable' style='margin-top: 28px'>
					<tbody>
						<tr>
							<td style='border-right: none'>Заключение на Акт ЛПО</td>
							<td :class='fields_correct.f_48'><datepicker
									v-model='f_48'
									format='dd.MM.yyyy'
									:disabled='readonly'
									class='table-control'
								></datepicker></td>
							<td :class='fields_correct.f_49'><input class="table-control form-control my-control" v-model='f_49' :disabled='readonly'></input></td>
							<td><input class="table-control form-control my-control" v-model='f_50' :disabled='readonly'></input></td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="col-md-2" style='margin-top: 20px'>
				<button @click.prevent='setRegistryAccordance' class="btn btn-default">Установить соответствие</button>
			</div>
			<div class="col-md-1" style='margin-top: 20px'>
				<span class='registry_stat_wrap'>
					<span class='registry_stat_title'>Статистика</span>
					<div class='registry_stat_popup'>
						<table>
							<tr>
								<th></th>
								<th>УПП</th>
								<th>МЗЛ</th>
							</tr>
							<tr>
								<td>Количество участков</td>
								<td>{{upp_count}}</td>
								<td>{{mzl_count}}</td>
							</tr>
							<tr>
								<td>Дата обновления</td>
								<td>{{upp_lastdate}}</td>
								<td>{{mzl_lastdate}}</td>
							</tr>
						</table>
					</div>
				</span>
			</div>
		</div>
		<div style='margin-bottom: 20px'></div>

		<div class="row">
			<div class="col-sm-12">
				<div class='table_head_wrap'>
					<table class='conclusion_place_table conclusion_place_table__top'>
						<thead>
							<tr>
								<th rowspan='2' class="form_td">Участковое лесничество</th>
								<th rowspan='2' class="form_td">Подлес-во</th>
								<th rowspan='2' class="form_td">Квартал</th>
								<th rowspan='2' class="form_td">Выдел</th>
								<th rowspan='2' class="form_td">Лп. выдел</th>
								<th rowspan='2' class="form_td">МЗЛ</th>
								<th colspan="5" class='colspan_td'>Соответствие</th>
								
								<th rowspan='2' class="form_td">Нарушение НПА</th>
								<th rowspan='2' class="form_td">Решение *</th>
								
								<th rowspan='2' class="form_td">Участки требующие проведения выездной проверки</th>
								<th colspan='2' class="form_td">Наличие в реестрах ГЛПМ</th>
								<th rowspan='2' class="form_td">Комментарии</th>
								<th rowspan='2' :width='scroll_width'></th>
							</tr>
							<tr>
								<th class="form_td" title='Соответствие сведений данным ГЛПМ'>свед. данным ГЛПМ</th>
								<th class="form_td" title='Соответствия сведений таксационным характеристикам лесного участка'>свед. ТО</th>
								<th class="form_td" title='Соответствие  мероприятий данным ГЛПМ'>мероприятий данным ГЛПМ</th>
								<th class="form_td" title='Запрещение или ограничение законодательством РФ мероприятий'>законодательству РФ</th>
								<th class="form_td" title='Недостоверность сведений санитарному и лесопатологическому состоянию лесов'>недост.свед. Сан. Сост.</th>
								<th class="form_td">УПП</th>
								<th class="form_td">МЗЛ-ПРВО</th>
							</tr>
						</thead>
					</table>
				</div>
				<div class='table_body_wrap'>
					<table class='conclusion_place_table conclusion_place_table__bottom'>
						<tbody>
							<template v-if='getActLocations(selected_act)'>
							<tr v-for='(line, index) in getActLocations(selected_act)'>
									<td class='form_td'>
										<input type="text" class='table-control form-control my-control' v-model='line.f_20' disabled></input>
									</td>
									<td class='form_td'>
										<input type="text" class='table-control form-control my-control' v-model='line.f_27' disabled></input>
									</td>
									<td class='form_td'>
										<input type="text" class='table-control form-control my-control' v-model='line.f_17' disabled></input>
									</td>
									<td class='form_td'>
										<input type="text" class='table-control form-control my-control' v-model='line.f_24' disabled></input>
									</td>
									<td class='form_td'>
										<input type="text" class='table-control form-control my-control' v-model='line.f_25' disabled></input>
									</td>
									<td class='form_td'>
										<input type="text" class='table-control form-control my-control' v-model='line.f_16' disabled></input>
									</td>
									<td class='form_td'>
										<select class='form-control form-control my-control table-control' v-model='line.f_28' :disabled='readonly'>
											<option value="2">Нет данных</option>
											<option value="1">Соответствует</option>
											<option value="0">Не соответствует</option>
										</select>
									</td>
									<td class='form_td'>
										<select class='form-control form-control my-control table-control' v-model='line.f_29' :disabled='readonly'>
											<option value="2">Нет данных</option>
											<option value="1">Соответствует</option>
											<option value="0">Не соответствует</option>
										</select>
									</td>
									<td class='form_td'>
										<select class='form-control form-control my-control table-control' v-model='line.f_30' :disabled='readonly'>
											<option value="2">Нет данных</option>
											<option value="1">Соответствует</option>
											<option value="0">Не соответствует</option>
										</select>
									</td>
									<td class='form_td'>
										<select class='form-control form-control my-control table-control' v-model='line.f_31' :disabled='readonly'>
											<option value="2">Нет данных</option>
											<option value="1">Соответствует</option>
											<option value="0">Не соответствует</option>
										</select>
									</td>
									<td class='form_td' style='border-right: none'>
										<select class='form-control form-control my-control table-control' v-model='line.f_32' :disabled='true'>
											<option value="2">Нет данных</option>
											<option value="1">Соответствует</option>
											<option value="0">Не соответствует</option>
										</select>
									</td>
									
									<td class='form_td' :class="{'field-error': line.f_31 == 0 && line.f_107 == 0}">
										<npa-violation :line_count='index' :id='line.f_107' :disabled='readonly'></npa-violation>
									</td>
									
									<td class='form_td' :class='line.correct_f_33'>
										<select class='form-control form-control my-control table-control' :value='line.f_33' :disabled='readonly' @change='decisionChange(line.f_33, $event)' :data-line='index'>
											<option value="2">Нет данных</option>
											<option value="1">Положительное</option>
											<option value="0">Отрицательное</option>
										</select>
									</td>
									<td class='form_td'>
										<input type="checkbox" :data-index='index' v-model='line.f_91' :disabled='readonly'></input>
									</td>
									<td class='form_td'>
										<input type="checkbox" :data-index='index' :checked='line.upp == "t"' disabled></input>
									</td>
									<td class='form_td'>
										<input type="checkbox" :data-index='index' :checked='line.mzl == "t"' disabled></input>
									</td>
									<td class='form_td'>
										<input type="text" class='table-control form-control my-control' v-model='line.f_34' :disabled='readonly'></input>
									</td>
							</tr>
							</template>
							<template v-else>
								<tr>
									<td>
										Загрузка...
									</td>
								</tr>
							</template>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-2 col"><span class="bold">Итоговое решение *</span></div>
			<div class="col-md-5 col">Главная причина отрицательного заключения</div>
			<div class="col-md-3 col">Примечание</div>
		</div>
		<div class="row">
			<div class="col-md-2 col flex">
				<select class='form-control form-control my-control' :value='f_41' :disabled='readonly' :class='fields_correct.f_41'
					@change='mainDecisionChange(f_41, $event)'>
					<option value="2">Нет данных</option>
					<option value="1">Положительное</option>
					<option value="0">Отрицательное</option>
				</select>

				<i 
					class='fa fa-asterisk button-spread' 
					title="Распространить соответствия на все акты в группе"
					@click="spreadActs"
				></i>
			</div>
			<div class="col-md-5 col"><decision-reason :disabled='readonly || f_41 > 0' :error='errorDecisionReason'></decision-reason></div>
			<div class="col-md-3 col"><input type="text" class='form-control my-control' v-model='f_43' :disabled='readonly'></input></div>
		</div>
		<div class="row">
			<div class="col-sm-9">
				<table class='documentsTable'>
					<thead>
						<tr>
							<th>Официальные документы</th>
							<th>Дата</th>
							<th>Номер</th>
							<th>Комментарий к документу</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td style='width: 30%; border-right: none'>Сопроводительное письмо с заключениями на Акты ЛПО</td>
							<td style='width: 23%'><datepicker
									v-model='f_44'
									format='dd.MM.yyyy'
									:disabled='readonly'
									class='table-control'
								></datepicker></td>
							<td style='width: 23%'><input class="table-control form-control my-control" v-model='f_45' :disabled='readonly'></input></td>
							<td style='width: 23%'><input class="table-control form-control my-control" v-model='f_46' :disabled='readonly'></input></td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="col-md-2">
				<select v-model='f_47' class='form-control form-control my-control medium' :disabled='readonly'>
					<option value="1">Черновик</option>
					<option value="0">Чистовик</option>
				</select>
			</div>
		</div>
		<div class="row" style='margin: 5px;'></div>
		<hr>

		<div class='btnPanel'>
			<input type='button' class='btn btn-secondary' @click.prevent="close" value='Отмена' :disabled="readonly"></input>
			<button class='btn btn-primary' @click.prevent='submit' :disabled="submit_disabled || readonly">
				<i class='fa fa-spinner fa-spin' v-if='submit_disabled'></i>
				{{ submit_disabled ? 'Сохранение' : 'Сохранить' }}
			</button>
		</div>

		<modal v-model="display_similar_acts" :backdrop='false' medium>
			<div slot="modal-header" class="modal-header">
			    <h4 class="modal-title">
			      <b>Редактирование состава группы</b>
			    </h4>
			  </div>
			<div>
				<ul class="acts-list">
					<li v-for='act in similar_acts'>
						<checkbox type='info' v-model='act.checked'> {{act.act_num}} </checkbox>
					</li>
				</ul>
			</div>
			<div slot="modal-footer" class="modal-footer">
				<button type="button" class="btn btn-default" @click='display_similar_acts = false'>Отмена</button>				
				<button type="button" class="btn btn-primary" @click='editGroup'>Сохранить</button>
			</div>
		</modal>

	</form>
</template>

<script>
	import router from '../../router'
	import {DB} from './../../constants'
	const HEADER = 'get_header.php'
	const LOCATION_GROUP = 'get_conclusion_location_group.php'
	const CONCLUSION_INFO = 'get_conclusion_info.php'
	const UPDATE_JSON = 'update_json.php'
	const SAVE_GROUP = 'save_group.php'
	const CAN_EDIT = 'can_edit_unit.php'
	const NPA_VIOLATION_NEW = 'get_npa_violation_new.php'
	const GET_GROUP = 'get_group.php'
	const EDIT_GROUP = 'edit_group.php'
	const FIND_GROUP = 'find_for_group.php'
	const UNIT_ID = 2
/*	const INSERT_JSON = 'insert_json.php'
	const UPDATE_JSON = 'update_json.php'
	const DELETE_JSON = 'delete_json.php'
	const JSON_U2 = 'get_json_u2.php'*/
//	const GET_PARENT = 'get_parent.php'

	import region from '../edit/fetch_data/region'
	import organization from './fetch_data/organization'
	import fo from '../edit/fetch_data/fo'

	import forestry from './fetch_data/forestry'
	import localforestry from './fetch_data/localforestry'
	import subforestry from './fetch_data/subforestry'
	import decisionReason from './fetch_data/decisionReason'
	import actionType from './fetch_data/actionType'
	import npaViolation from './fetch_data/npaViolation'

	import { datepicker, modal, checkbox } from 'vue-strap'

	import moment from 'moment';
	// import jQuery from "jquery"; 
	// import datePicker from 'vue-bootstrap-datetimepicker';
	//import datePicker from './../datePicker'

	import { EventBus } from '../../lib/EventBus'

	export default {
		name: 'groupConclusion',
		data: function () {
			return {
				scroll_width: 17,
				readonly: true,
				line_count: 0,
				selected_act: 0,
				similar_acts: [],
				saved_act: [],
				display_similar_acts: false,
				lines: [],
				group_acts: [],
				group_id: this.$route.params.id,
				//action: '',
				//old_obj: '',
				
				f_2: '',
				f_4: '',
				f_11: '',
				f_9: '',
				f_12: '',

				f_35: '',
				f_36: '',
				f_37: '',
				f_38: '',
				f_39: '',
				f_40: '',
				f_41: 2,
				f_42: 2,
				f_43: '',
				f_44: '',
				f_45: '',
				f_46: '',
				f_47: 1,
				f_48: '',
				f_49: '',
				f_50: '',

				upp_count: 0,
				mzl_count: 0,
				upp_lastdate: '',
				mzl_lastdate: '',

				f_28: [],
				f_29: [],
				f_30: [],
				f_31: [],
				f_32: [],
				f_33: [],
				f_34: [],

				f_17: [],
				f_24: [],
				f_25: [],

				f_0: [],
				location_id: [],

				fields_correct: {
					f_35: 'field-error',
					f_36: 'field-error',
					// f_38: 'field-error',
					// f_39: 'field-error',
					f_41: 'field-error',
					// f_44: 'field-error',
					// f_45: 'field-error',
					f_48: 'field-error',
					f_49: 'field-error',
				},

				submit_disabled: false,
				npa_violations: [],
				errorDecisionReason: false,
				data_is_loaded: false

			}
		},
		components: {
			region,
			forestry,
			localforestry,
			subforestry,
			organization,
			fo,
			decisionReason,
			actionType,
			datepicker,
			modal,
			npaViolation,
			checkbox
		},
		methods: {
			spreadActs() {
				const firstLine = this.lines[this.getSelectedActIndex()][0]
				for(let act_index in this.lines) {
					for(let line in this.lines[act_index]) {
						if(line == 'act_id')
							continue

						this.lines[act_index][line].f_28 = firstLine.f_28
						this.lines[act_index][line].f_29 = firstLine.f_29
						this.lines[act_index][line].f_30 = firstLine.f_30
						this.lines[act_index][line].f_31 = firstLine.f_31
						this.lines[act_index][line].f_33 = firstLine.f_33
						this.lines[act_index][line].f_107 = firstLine.f_107
					}
				}		
			},
			getActLocations (id) {
				for(let line of this.lines)
				{
					if(line.act_id == id)
					{
						return line
					}
				}
				return false
			},
			checkActInGroup (act_id) {
				for(let act of this.group_acts)
				{
					if(act.act_id == act_id)
						return true
				}
				return false
			},
			getSelectedActIndex () {
				let selected_act_index = null
				for(let i in this.lines) {
					if(this.lines[i].act_id == this.selected_act) {
						selected_act_index = i
						break
					}
				}
				return selected_act_index
			},
			setRegistryAccordance () {
				let selected_act_index = this.getSelectedActIndex()

				for(let i in this.lines[selected_act_index])
				{
					if(i == 'act_id')
						continue
					
					if(this.lines[selected_act_index][i].upp == 't') {
						if(this.lines[selected_act_index][i].accordance_upp == 't')
							this.lines[selected_act_index][i].f_28 = 1 
						if(this.lines[selected_act_index][i].accordance_upp == 'f')
							this.lines[selected_act_index][i].f_28 = 0
					} else 
						this.lines[selected_act_index][i].f_28 = 2

					if(this.lines[selected_act_index][i].accordance_mzl == 't')
							this.lines[selected_act_index][i].f_30 = 1 
					else if(this.lines[selected_act_index][i].accordance_mzl == 'f')
							this.lines[selected_act_index][i].f_30 = 0
					else 
						this.lines[selected_act_index][i].f_30 = 2
				}
			},
			decisionChange (old, e) {
				let selected_act_index = this.getSelectedActIndex()
				const l = e.target.getAttribute('data-line')

				this.lines[selected_act_index][l].f_33 = e.target.value
				this.lines[selected_act_index][l][`correct_f_33`] = e.target.value == '2' ? 'field-error' : 'place-success'
				if(this.f_41 == '1' && e.target.value == '0')
					this.f_41 = '0'

				if(old == '2' && e.target.value == '1')
				{
					this.lines[selected_act_index][l].f_28 = '1'
					this.lines[selected_act_index][l].f_29 = '1'
					this.lines[selected_act_index][l].f_30 = '1'
					this.lines[selected_act_index][l].f_31 = '1'
				}
			},
			mainDecisionChange (old, e) {
				let selected_act_index = this.getSelectedActIndex()

				this.f_41 = e.target.value
				if(e.target.value == '0' || e.target.value == '1') {
					for(let act_index in this.lines)
						for(let line in this.lines[act_index])
							{
								if(line == 'act_id')
									continue

								this.lines[act_index][line].f_28 = e.target.value
								this.lines[act_index][line].f_29 = e.target.value
								this.lines[act_index][line].f_30 = e.target.value
								this.lines[act_index][line].f_31 = e.target.value
								this.lines[act_index][line].f_33 = e.target.value
								this.lines[act_index][line][`correct_f_33`] = 'place-success'
							}
				}
					
			},
			checkFields () {
				return true
				const main_fields = [35,36,48,49]
				// const location_fields = [33]

				let result = true
				
				for (let i of main_fields) {
					result = result && !!this[`f_${i}`]	//one false = result false, all true = result true
				}

				result = result && (this.f_41 != '2')

				result = result && !!this.lines.length	//lines.length == 0 => result false

				for (let j = 0; j < this.lines.length; j++) {
					result = result && (this.lines[j].f_33 != '2')
				}

				return result
			},
			submit () {
				//console.warn(this.lines)

				this.submit_disabled = true
				let obj = []

				let counter = 0
				for(let act of this.group_acts) {
					obj.push({})
					obj[counter].tab_id = 1
					obj[counter].f_v = {}
					obj[counter].f_v.f_c = act.act_id
					
					for (let i = 35; i <= 50; i++) {
						if (this[`f_${i}`] !== '') {
							if (typeof this[`f_${i}`] !== 'object') {
								if (i === 41)
									obj[counter].f_v[`f_${i}`] = this[`f_${i}`] != '2' ? (this[`f_${i}`] == '1' ? true : false) : null
								else if (i === 36 || i === 39 || i === 45 || i === 49)
									obj[counter].f_v[`f_${i}`] = commaToPeriod(this[`f_${i}`])
								else 
									obj[counter].f_v[`f_${i}`] = this[`f_${i}`]
							}
							else {
								obj[counter].f_v[`f_${i}`] = this[`f_${i}`].format('DD.MM.YYYY')
							}

						}
						else {
							obj[counter].f_v[`f_${i}`] = null
						}
					}

					if(obj[counter].f_v.f_41 != false)
						obj[counter].f_v.f_42 = null

					counter++
				}

				//let counter = 0
				for(let line of this.lines) {

					//console.warn(line)

					for(let i in line) {
						if(i == 'act_id')
							continue

						obj.push({})

						obj[counter].tab_id = 2
						obj[counter].f_v = {}
						obj[counter].f_v.f_c = line[i].f_c

						for (let j = 28; j <= 33; j++) {
							obj[counter].f_v[`f_${j}`] = line[i][`f_${j}`] != '2' ? (line[i][`f_${j}`] == '1' ? true : false) : null
						}

						obj[counter].f_v.f_34 = line[i].f_34 ? line[i].f_34 : null
						obj[counter].f_v.f_91 = line[i].f_91
						obj[counter].f_v.f_107 = line[i].f_107
						counter++
					}
					
				}
				
				//console.log(JSON.stringify(obj)) 

				const submit_conclusion_info = () => {
					let form = new FormData()
					form.append('json', JSON.stringify(obj))

					fetch(DB + UPDATE_JSON, {
						credentials: 'include',
						method: 'post',
						body: form
					})
					.then(result => result.json())
					.then(result => {
						if(result[0].code === '0') {
							alert('Заключение на группу актов сохранено')

							if(this.$parent.lastJournalURL)
								router.replace(this.$parent.lastJournalURL)
							else
								router.replace('/main')
						}
						else {
							alert(result[0].name)
						}
						this.submit_disabled = false
					})
					.catch(err => console.log(err))
				}

				if (this.checkFields()) {
					if(this.errorDecisionReason)
					{
						alert("Выбранная главная причина отрицательного заключения отсутствует среди соответствий")
					}
					if(document.querySelector('.field-error') !== null)
					{
						alert('Часть полей содержит некорректные данные. Сохранение невозможно')
						this.submit_disabled = false
					} else {
						//console.warn(JSON.stringify(obj))
						submit_conclusion_info()
					}				
				}
				else {
					alert('Поля, отмеченные звёздочкой, обязательны к заполнению.')
					this.submit_disabled = false
				}
			},
			close () {
				if(this.$parent.lastJournalURL)
					router.replace(this.$parent.lastJournalURL)
				else
					router.replace('/main')
			},
			errorDecisionReasonHandler () {
				this.errorDecisionReason = false
				if(Number(this.f_41) == 0)
				{
					let array = []

					const selected_act_index = this.getSelectedActIndex()
					let error = false
					for(let act of this.lines) {
						for(let line of act) {
							for(let i = 28; i <= 31; i++)
							{
								array[i] = array[i] || (line[`f_${i}`] == 0)
							}
						}

						if(this.f_42 == 1)
							error = !array[31]
						if(this.f_42 == 2)
							error = !array[30]
						if(this.f_42 == 3)
							error = !array[28]
						if(this.f_42 == 4)
							error = !array[29]

						if(error) {
							this.errorDecisionReason = true
							break
						}

					}
					
				}
			},
			loadConclusionData () {
				if(this.data_is_loaded)
					return

				this.data_is_loaded = true

				EventBus.$off('decision_reason')
				EventBus.$on('decision_reason', (id) => {
					this.f_42 = id
				})

				EventBus.$off('npa_violation')
				EventBus.$on('npa_violation', (data) => {
					//console.warn(this.getActLocations(this.selected_act)[data.index].f_107)
					this.getActLocations(this.selected_act)[data.index].f_107 = data.value
					//console.warn(this.getActLocations(this.selected_act)[data.index].f_107)
				})

				EventBus.$off('showSimilarActs')
				EventBus.$on('showSimilarActs', this.showSimilarActs)

				fetch(DB + CAN_EDIT + '?act_id=' + this.selected_act + '&unit_id=' + UNIT_ID, {
				credentials: 'include'
				})
				.then(res => res.json())
				.then(res => {
					this.readonly = res[0].czl_check_can_edit_unit == 't' ? false : true
				})
				.catch(err => console.log(err))


				fetch(DB + HEADER + '?id=' + this.selected_act, {
					credentials: 'include'
				})
				.then(res => res.json())
				.then(res => {
					//console.log('header:');
					//console.log(res);
					for (let i in res[0]) {
						//if(!this[i])
						this[i] = res[0][i]
					}

					this.loadConclusionData2()
				})
				.catch(err => console.log(err))


				fetch(DB + LOCATION_GROUP + '?id=' + this.group_id, {
					credentials: 'include'
				})
				.then(res => res.json())
				.then(res => {
					//console.log('location group:');
					//console.log(res);
					for(let location of res) {
						let found_id = false
						for(let i in this.lines) {
							if(this.lines[i].act_id == location.f_p) {
								this.lines[i].push(location)
								found_id = i
							}
						}
						if(found_id === false) {
							const obj = []
							obj['act_id'] = location.f_p
							obj.push(location)
							this.lines.push(obj)
						}
					}

					for (let i = 0; i < this.lines.length; i++) {
						for(let ii in this.lines[i]) {
							if(ii == 'act_id')
								continue

							for (let j = 28; j <= 33; j++) {
								this.lines[i][ii][`f_${j}`] = this.lines[i][ii][`f_${j}`] ? (this.lines[i][ii][`f_${j}`] === 't' ? 1 : 0) : 2
							}
							this.lines[i][ii].correct_f_33 = this.lines[i][ii].f_33 === 2 ? 'field-error' : ''
							this.lines[i][ii].f_91 = this.lines[i][ii].f_91 ? (this.lines[i][ii].f_91 === 't' ? true : false) : false
							
						}
					}

					//console.warn(this.lines)

					/*if (res && !this.getActLocations(this.selected_act)) {
						let locations = res
						locations.act_id = this.selected_act
						this.lines.push(locations)
						console.warn(this.lines)
					}

					for (let i = 0; i < res.length; i++) {
						for (let j = 28; j <= 33; j++) {
							this.getActLocations(this.selected_act)[i][`f_${j}`] = res[i][`f_${j}`] ? ((res[i][`f_${j}`] === 't') ? 1 : 0) : 2
						}
						this.getActLocations(this.selected_act)[i].correct_f_33 = res[i].f_33 === 2 ? 'field-error' : ''

						this.getActLocations(this.selected_act)[i].f_91 = res[i].f_91 ? ((res[i].f_91 === 't') ? true : false) : false
					}*/
				})
				.catch(err => console.log('9',err))
				

				
			},
			loadConclusionData2 () {
				if(this.selected_act) {
					fetch(DB + CONCLUSION_INFO + '?id=' + this.selected_act, {
						credentials: 'include'
					})
					.then(res => res.json())
					.then(res => {
						//console.log('conclusion info:');
						//console.log(res);
						if (res) {
							for (let i in res[0]) {
								if (res[0][i]) {
									if(!this[i])
									{
										if (i === 'f_35' || i === 'f_38' || i === 'f_44' || i === 'f_48') {
											let d = moment(res[0][i], 'YYYY-MM-DD')
											// console.log(res[0][i], d.format('DD.MM.YYYY'))
											this[i] =  res[0][i] ? d.format('DD.MM.YYYY') : ''
										}
										else if (i === 'f_47' || i === 'f_41') {
											this[i] = res[0][i] === 't' ? 1 : 0
										}
										else {
											this[i] = res[0][i]
										}
									}
								}
							}

							this.fields_correct.f_41 = (res[0].f_41 == 2 || res[0].f_41 === null) ? 'field-error' : ''
						}
					})
					.catch(err => console.log(err))

					const act_date = moment(this.f_48, "YYYY-MM-DD")
					let formattedDate
					if(act_date.isValid()) {
						formattedDate = act_date.format("DD.MM.YYYY")
					} else {
						formattedDate = moment().format("DD.MM.YYYY")
					}

					fetch(DB + NPA_VIOLATION_NEW + '?date=' + formattedDate, {
						credentials: 'include'
					})
					.then(data => data.json())
					.then(data => {
						//console.log('npm violation');
						//console.log(data);
						if(data)
						{
							this.npa_violations = data
							EventBus.$emit('fetch_npa_violations_complete')
						}
					})
					.catch(err => console.log(err))
				}

				
			},
			showSimilarActs () {
				fetch(DB + FIND_GROUP + '?act_id=' + this.selected_act, {
					credentials: 'include'
				})
				.then(res => res.json())
				.then(res => {
					//console.warn(res)
					this.similar_acts = res
					for(let act in this.similar_acts)
					{
						this.similar_acts[act].checked = this.checkActInGroup(this.similar_acts[act].act_id)
					}
					this.display_similar_acts = true

				})
				.catch(err => console.log(err))
			},
			editGroup () {
				const ids = []
				for(let act of this.similar_acts) {
					if(act.checked)
						ids.push(act.act_id)
				}

				fetch(DB + EDIT_GROUP + '?group_id=' + this.group_id + '&ids=' + ids.join(','), {
					credentials: 'include'
				})
				.then(res => res.json())
				.then(res => {
					window.location.reload()
				})
				.catch(err => console.log(err))
			}
		},
		created () {
			fetch(DB + GET_GROUP + '?group_id=' + this.group_id, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				//console.log('group');
				//console.log(res);
				this.group_acts = res
				this.selected_act = this.group_acts[0].act_id

				this.loadConclusionData()
			})
			.catch(err => console.log(err))
			
			const ua = navigator.userAgent

			if (ua.search('OPR/') > 0) {
				this.scroll_width = 15
			}
		},
		mounted () {
			this.loadConclusionData2()
		},
		beforeDestroy () {
			EventBus.$off('decision_reason')
		},
		watch: {
			//[35,36,38,39,44,45,48,49]
			async selected_act (id) {
				this.loadConclusionData()
				this.loadConclusionData2()
				this.$forceUpdate()
			},
			lines: {
				handler: function () {
					this.errorDecisionReasonHandler()
				},
				deep: true
			},
			f_41 (e) {
				this.fields_correct.f_41 = (e === '2' || e === null) ? 'field-error' : ''
				this.errorDecisionReasonHandler()
			},
			f_42 () {
				this.errorDecisionReasonHandler()
			},
			f_35 (e) {
				const arr_f_35 = this.f_35.split('.')
				const date_f_35 = new Date(+arr_f_35[2], (+arr_f_35[1] - 1), +arr_f_35[0])
				const arr_f_48 = this.f_48.split('.')
				const date_f_48 = new Date(+arr_f_48[2], (+arr_f_48[1] - 1), +arr_f_48[0])
				if(date_f_35 > date_f_48)
				{
					this.fields_correct.f_35 = 'field-error'
					this.fields_correct.f_48 = 'field-error'
				} else {
					this.fields_correct.f_35 = (e === '' || e === null) ? 'field-error' : 'field-success'
					//this.fields_correct.f_48 = 'field-success'
				}
			},
			f_36 (e) {
				this.fields_correct.f_36 = (e === '' || e === null) ? 'field-error' : 'place-success'
			},
			f_38 (e) {
				this.fields_correct.f_38 = (e === '' || e === null) ? 'field-error' : 'field-success'
			},
			f_39 (e) {
				this.fields_correct.f_39 = (e === '' || e === null) ? 'field-error' : ''
			},
			f_44 (e) {
				this.fields_correct.f_44 = (e === '' || e === null) ? 'field-error' : 'field-success'
			},
			f_45 (e) {
				this.fields_correct.f_45 = (e === '' || e === null) ? 'field-error' : ''
			},
			f_48 (e) {
				const arr_f_35 = this.f_35.split('.')
				const date_f_35 = new Date(+arr_f_35[2], (+arr_f_35[1] - 1), +arr_f_35[0])
				const arr_f_48 = this.f_48.split('.')
				const date_f_48 = new Date(+arr_f_48[2], (+arr_f_48[1] - 1), +arr_f_48[0])
				if(date_f_35 > date_f_48)
				{
					this.fields_correct.f_35 = 'field-error'
					this.fields_correct.f_48 = 'field-error'
				} else {
					this.fields_correct.f_35 = 'field-success'
					this.fields_correct.f_48 = (e === '' || e === null) ? 'field-error' : 'field-success'
				}
			},
			f_49 (e) {
				this.fields_correct.f_49 = (e === '' || e === null) ? 'field-error' : ''
			},
		}
	}

	function commaToPeriod(str) {
		return str.replace(/,/g, ".")
	}
</script>

<style>

	div.datepicker {
		width: 100%;
	}

	.conclusion_place_table .table-control {
		font-size: 9px !important;
	}

	.conclusion_place_table td.form_td,
	.conclusion_place_table th.form_td {
		font-size: 9px;
		/*width: 6.66%;*/
	}

	.conclusion_place_table th.form_td {
		border-bottom: none;
		font-size: 9px;
	}

	.conclusion_place_table {
		margin-bottom: 5px;
		width: 100%;
		border: solid 1px;
	}

	.conclusion_place_table tr, .conclusion_place_table thead, .conclusion_place_table tbody {
		border: none;
	}

	.my-control {
		padding-left: 5px !important;
		padding-top: 0px !important;
		padding-bottom: 0px !important;
		margin-bottom: 5px;
		height: 24px;
		display: inline-table !important;
		font-size: 12px !important;
	}

	select.my-control:not([size]):not([multiple]) {
		height: 24px;
	}

	.table-control {
		height: 24px;
		width: 100%;
		margin: 0px;
		border: none !important;
	}

	.registry_stat_wrap {
		position: relative;
	}

	.registry_stat_title {
		text-decoration: underline;
		cursor: pointer;
		height: 34px;
	    line-height: 34px;
	    font-size: 14px;
	}

	.registry_stat_popup {
		display: none;
		position: absolute;
		z-index: 99999;
		right: 0px;
		background-color: #fff;
		border: 1px solid #ccc;
		border-radius: 3px;
		padding: 5px;
	}

	.registry_stat_popup table {
		width: 300px;
		border: none;
	}

	.registry_stat_popup table td,
	.registry_stat_popup table th {
		border: 1px solid #ddd;
		padding: 5px;
		text-align: center;
	}

	.registry_stat_wrap:hover .registry_stat_popup {
		display: block !important;
	}

	.acts-list {
		list-style-type: none;
		padding-left: 0 !important;
	}

	.acts-list ul {
		margin-bottom: 0;
	}

	.acts-list li {
		border-top: 1px solid #e2e7ff;
    	border-bottom: 1px solid #e2e7ff;
    	margin-bottom: -1px;
	}

	.acts-list label {
		font-size: 15px;
		font-weight: 100 !important;
	}

	.flex {
		display: flex;
	}

	.button-spread {
		height: 24px;
		width: 24px;
		border: 1px solid #ccc;
		border-radius: 4px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-left: 5px;
		cursor: pointer;
	}

	.button-spread:hover {
		background-color: #eee;
	}
</style>


// WEBPACK FOOTER //
// groupConclusionForm.vue?2013d179